export const css = {
    root: 'erXAtrRz',
    text: '_0W6NB2XJ',
    contained: '-DCzXZcO',
    outlined: '_40aOqbhk',
    popup: 'MIRwDa3z',
    label: 'KcXZ55nf',
    icon: '_9S3FKlKJ',
    iconOnly: '-Wh5-7kl',
    disabled: 'gjPDuBYC',
    dark: 'ANNoxGOV',
    ' _key': 'mc-widgets/card-button'
};
export default css;
